export class ClientReferralMember implements IClientReferralMember {
  id!: number;
  providerPlatformAccountUuid!: string;
  status!: ClientReferralMemberStatus;
  expiredReason!: ClientReferralMemberExpiredReason;

  constructor(json: IClientReferralMemberApiResponse) {
    this.id = json.id;
    this.providerPlatformAccountUuid = json.provider_platform_account_uuid;
    this.status = json.status;
    this.expiredReason = json.expired_reason;
  }
}

export enum ClientReferralMemberStatus {
  MATCHED = 'matched',
  CARE_TEAM = 'care_team',
  ARCHIVED = 'archived'
}

export enum ClientReferralMemberExpiredReason {
  ADMINISTRATOR = 'administrator',
  REFERRAL_CANCELED = 'referral_canceled',
  NO_LONGER_ACCEPTING_CLIENTS = 'no_longer_accepting_clients',
  CLIENT_SCHEDULED_WITH_OTHER_PROVIDER = 'client_scheduled_with_other_provider',
  PROVIDER_NO_LONGER_ACTIVE = 'provider_no_longer_active',
  CLIENT_UPDATED_PREFERENCES = 'client_updated_preferences',
  CLIENT_REQUESTED_REMATCH = 'client_requested_rematch',
  CLIENT_ARCHIVED = 'client_archived'
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface IClientReferralMemberApiResponse {
  id: number;
  provider_platform_account_uuid: string;
  status: ClientReferralMemberStatus;
  expired_reason: ClientReferralMemberExpiredReason;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IClientReferralMember {
  id: number;
  providerPlatformAccountUuid: string;
  status: ClientReferralMemberStatus;
  expiredReason: ClientReferralMemberExpiredReason;
}
